export default "__VITE_ASSET___Kks0ryF__"